import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import GroupOutlinedIcon from "@material-ui/icons/GroupOutlined";
import WarningIcon from "@material-ui/icons/Warning";
import TuneIcon from "@material-ui/icons/Tune";
import ClearAllIcon from "@material-ui/icons/ClearAll";
import InputBase from "@material-ui/core/InputBase";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import MoveToInboxIcon from "@material-ui/icons/MoveToInbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Drawer from "@material-ui/core/Drawer";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsList";
import TabPanel from "../TabPanel";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { Button } from "@material-ui/core";
import api from "../../services/api";
import openSocket from "../../services/socket-io";

const useStyles = makeStyles((theme) => ({
  "@keyframes tabPulseGlow": {
    "0%": {
      transform: "translateY(0) scale(1)",
      boxShadow: "0 0 0 rgba(20, 184, 166, 0)",
    },
    "35%": {
      transform: "translateY(-1px) scale(1.01)",
      boxShadow:
        theme.palette.type === "dark"
          ? "0 12px 30px rgba(20, 184, 166, 0.24)"
          : "0 14px 32px rgba(20, 184, 166, 0.22)",
    },
    "100%": {
      transform: "translateY(0) scale(1)",
      boxShadow: "0 0 0 rgba(20, 184, 166, 0)",
    },
  },
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  tabsHeader: {
    flex: "none",
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, rgba(19,49,43,0.96) 0%, rgba(11,23,20,0.94) 100%)"
        : "linear-gradient(180deg, rgba(250,255,252,0.98) 0%, rgba(239,248,244,0.92) 100%)",
    borderBottom: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(52, 211, 153, 0.12)"
        : "rgba(18, 140, 126, 0.12)"
    }`,
  },
  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: 8,
  },
  tab: {
    minWidth: 120,
    width: 120,
    minHeight: 68,
    fontWeight: 700,
    letterSpacing: "0.02em",
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background:
      theme.palette.type === "dark"
        ? "rgba(19,49,43,0.86)"
        : "rgba(255,255,255,0.92)",
    padding: theme.spacing(1.25, 1.25, 1),
    borderBottom: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.06)"
        : "rgba(15, 23, 42, 0.06)"
    }`,
    boxShadow:
      theme.palette.type === "dark"
        ? "inset 0 -1px 0 rgba(255,255,255,0.03)"
        : "inset 0 -1px 0 rgba(255,255,255,0.8)",
  },
  serachInputWrapper: {
    flex: 1,
    background: theme.palette.background.paper,
    display: "flex",
    borderRadius: 16,
    padding: "6px 10px",
    marginRight: theme.spacing(1),
    border: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(52, 211, 153, 0.16)"
        : "rgba(18, 140, 126, 0.14)"
    }`,
    boxShadow:
      theme.palette.type === "dark"
        ? "0 8px 18px rgba(2, 6, 23, 0.22)"
        : "0 8px 18px rgba(15, 23, 42, 0.06)",
  },
  searchIcon: {
    color: theme.palette.text.secondary,
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },
  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 12,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
  },
  badge: {
    right: "-12px",
  },
  show: {
    display: "block",
  },
  hide: {
    display: "none !important",
  },
  primaryTabs: {
    minHeight: 78,
  },
  primaryTabRoot: {
    minHeight: 78,
    fontWeight: 700,
    letterSpacing: "0.03em",
    color: theme.palette.text.secondary,
    borderRadius: 22,
    margin: theme.spacing(0.5, 1),
    transition: "background-color 180ms ease, box-shadow 180ms ease, transform 180ms ease",
    "&.Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  primaryTabLabelWrap: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
  },
  primaryTabLabelText: {
    fontWeight: 700,
  },
  primaryTabCounters: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  primaryCounterPill: {
    minWidth: 20,
    height: 20,
    padding: "0 6px",
    borderRadius: 999,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.72rem",
    fontWeight: 800,
    lineHeight: 1,
    color: "#fff",
  },
  primaryCounterPending: {
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, #f59e0b 0%, #d97706 100%)"
        : "linear-gradient(180deg, #fb923c 0%, #f97316 100%)",
  },
  primaryCounterUnread: {
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, #34d399 0%, #059669 100%)"
        : "linear-gradient(180deg, #22c55e 0%, #16a34a 100%)",
  },
  primaryTabAlert: {
    animation: "$tabPulseGlow 1.4s ease",
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(circle at top, rgba(45, 212, 191, 0.22) 0%, rgba(45, 212, 191, 0.08) 45%, rgba(45, 212, 191, 0) 85%)"
        : "radial-gradient(circle at top, rgba(45, 212, 191, 0.26) 0%, rgba(45, 212, 191, 0.12) 45%, rgba(45, 212, 191, 0) 85%)",
  },
  primaryTabAlertSelected: {
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(circle at top, rgba(45, 212, 191, 0.26) 0%, rgba(45, 212, 191, 0.12) 45%, rgba(45, 212, 191, 0.02) 100%)"
        : "radial-gradient(circle at top, rgba(45, 212, 191, 0.3) 0%, rgba(45, 212, 191, 0.14) 45%, rgba(45, 212, 191, 0.02) 100%)",
  },
  secondaryTabs: {
    background:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.02)"
        : "rgba(255,255,255,0.72)",
    borderTop: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.04)"
        : "rgba(255,255,255,0.7)"
    }`,
  },
  secondaryTabRoot: {
    minHeight: 72,
    fontWeight: 700,
    letterSpacing: "0.03em",
    color: theme.palette.text.secondary,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  statusTabs: {
    minHeight: 56,
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, rgba(20,35,31,0.96) 0%, rgba(11,23,20,0.98) 100%)"
        : "linear-gradient(180deg, rgba(255,255,255,0.94) 0%, rgba(246,248,252,0.96) 100%)",
    borderBottom: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.06)"
        : "rgba(15, 23, 42, 0.06)"
    }`,
  },
  statusTabRoot: {
    minHeight: 56,
    fontWeight: 700,
    color: theme.palette.text.secondary,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  actionButton: {
    borderRadius: 14,
    padding: "10px 18px",
    fontWeight: 700,
    borderColor: `rgba(${theme.palette.type === "dark" ? "52, 211, 153" : "18, 140, 126"}, 0.25)`,
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, rgba(19,49,43,0.98) 0%, rgba(15,36,31,0.98) 100%)"
        : "linear-gradient(180deg, #ffffff 0%, #f6fbf8 100%)",
    boxShadow:
      theme.palette.type === "dark"
        ? "0 10px 20px rgba(2, 6, 23, 0.20)"
        : "0 10px 20px rgba(18, 140, 126, 0.08)",
  },
  connectionAlert: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    background:
      theme.palette.type === "dark"
        ? "rgba(245, 158, 11, 0.12)"
        : "rgba(245, 158, 11, 0.08)",
    borderBottom: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(245, 158, 11, 0.18)"
        : "rgba(245, 158, 11, 0.16)"
    }`,
    color: theme.palette.text.primary,
    fontSize: "0.88rem",
  },
  connectionAlertIcon: {
    fontSize: 18,
    color: theme.palette.warning.main,
    flex: "none",
  },
  filterToggleButton: {
    borderRadius: 14,
    padding: "10px 14px",
    fontWeight: 700,
    minWidth: 0,
    marginLeft: theme.spacing(1),
  },
  activeFiltersSummary: {
    padding: theme.spacing(0, 1.25, 1),
    color: theme.palette.text.secondary,
    fontSize: "0.84rem",
    fontWeight: 600,
  },
  drawerPaper: {
    width: "100%",
    maxWidth: 420,
    padding: theme.spacing(2, 2, 2.5),
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, rgba(12,28,24,0.98) 0%, rgba(7,16,14,0.98) 100%)"
        : "linear-gradient(180deg, rgba(255,255,255,0.99) 0%, rgba(246,250,252,0.99) 100%)",
  },
  drawerHeader: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(2),
  },
  drawerTitle: {
    fontSize: "1.1rem",
    fontWeight: 800,
    color: theme.palette.text.primary,
  },
  drawerSubtitle: {
    fontSize: "0.88rem",
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  },
  advancedFiltersWrap: {
    display: "grid",
    gap: theme.spacing(1.25),
  },
  advancedFiltersGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: theme.spacing(1.25),
    alignItems: "end",
  },
  filterField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 14,
      backgroundColor: theme.palette.background.paper,
    },
  },
  advancedFiltersFooter: {
    marginTop: theme.spacing(1.5),
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: "0.84rem",
  },
  filterHint: {
    color: theme.palette.text.secondary,
  },
  drawerActions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
  drawerPrimaryActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    marginLeft: "auto",
  },
}));

const TicketsManager = ({
  forcedTicketType = null,
  hideTicketTypeTabs = false,
}) => {
  const classes = useStyles();
  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [tabOpen, setTabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const searchInputRef = useRef();
  const { user } = useContext(AuthContext);
  const { whatsApps = [] } = useContext(WhatsAppsContext);
  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [ticketType, setTicketType] = useState(forcedTicketType || "private");
  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const hasGroupEnabledConnection = useMemo(
    () => whatsApps.some((whatsApp) => whatsApp.allowGroupMessages),
    [whatsApps]
  );
  const shouldForceTicketTypeTabsForUser =
    user?.profile?.toLowerCase() === "user";
  const shouldShowTicketTypeTabs =
    !hideTicketTypeTabs &&
    (Boolean(forcedTicketType) ||
      hasGroupEnabledConnection ||
      shouldForceTicketTypeTabsForUser);
  const queueIdsParam = JSON.stringify(selectedQueueIds);
  const [privatePendingCount, setPrivatePendingCount] = useState(0);
  const [groupPendingCount, setGroupPendingCount] = useState(0);
  const [privateUnreadCount, setPrivateUnreadCount] = useState(0);
  const [groupUnreadCount, setGroupUnreadCount] = useState(0);
  const [whatsAppHealth, setWhatsAppHealth] = useState(null);
  const [advancedFiltersOpen, setAdvancedFiltersOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedWhatsAppId, setSelectedWhatsAppId] = useState("");
  const [selectedTagValues, setSelectedTagValues] = useState([]);
  const [draftSelectedQueueIds, setDraftSelectedQueueIds] = useState(userQueueIds || []);
  const [draftSelectedDate, setDraftSelectedDate] = useState("");
  const [draftSelectedUserId, setDraftSelectedUserId] = useState("");
  const [draftSelectedWhatsAppId, setDraftSelectedWhatsAppId] = useState("");
  const [draftSelectedTagValues, setDraftSelectedTagValues] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    users: [],
    queues: [],
    whatsapps: [],
    tags: []
  });
  const [tabActivity, setTabActivity] = useState({
    private: false,
    group: false
  });
  const tabActivityTimeoutsRef = useRef({});
  const recentTabMessageIdsRef = useRef(new Set());

  const selectedUserIds = useMemo(
    () => (selectedUserId ? [Number(selectedUserId)] : []),
    [selectedUserId]
  );
  const selectedWhatsAppIds = useMemo(
    () => (selectedWhatsAppId ? [Number(selectedWhatsAppId)] : []),
    [selectedWhatsAppId]
  );
  const selectedTagIds = useMemo(
    () =>
      selectedTagValues
        .map(value => Number(value))
        .filter(value => !Number.isNaN(value)),
    [selectedTagValues]
  );
  const availableQueues = useMemo(
    () =>
      Array.isArray(filterOptions.queues) && filterOptions.queues.length
        ? filterOptions.queues
        : user?.queues || [],
    [filterOptions.queues, user?.queues]
  );
  const defaultQueueIdsKey = useMemo(
    () => JSON.stringify([...(userQueueIds || [])].sort((left, right) => left - right)),
    [userQueueIds]
  );
  const selectedQueueIdsKey = useMemo(
    () => JSON.stringify([...(selectedQueueIds || [])].sort((left, right) => left - right)),
    [selectedQueueIds]
  );
  const hasAdvancedFiltersApplied = Boolean(
    selectedDate ||
      selectedUserId ||
      selectedWhatsAppId ||
      selectedTagValues.length > 0 ||
      selectedQueueIdsKey !== defaultQueueIdsKey
  );
  const activeAdvancedFiltersCount =
    (selectedDate ? 1 : 0) +
    (selectedUserId ? 1 : 0) +
    (selectedWhatsAppId ? 1 : 0) +
    (selectedTagValues.length > 0 ? 1 : 0) +
    (selectedQueueIdsKey !== defaultQueueIdsKey ? 1 : 0);

  useEffect(() => {
    if (user.profile.toUpperCase() === "ADMIN") {
      setShowAllTickets(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (forcedTicketType) {
      setTicketType(forcedTicketType);
    }
  }, [forcedTicketType]);

  useEffect(() => {
    if (
      !forcedTicketType &&
      !hasGroupEnabledConnection &&
      !shouldForceTicketTypeTabsForUser &&
      ticketType === "group"
    ) {
      setTicketType("private");
    }
  }, [
    forcedTicketType,
    hasGroupEnabledConnection,
    shouldForceTicketTypeTabsForUser,
    ticketType
  ]);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
      setSearchParam("");
    }
  }, [tab]);

  const refreshWhatsAppHealth = useCallback(async () => {
    try {
      const { data } = await api.get("/whatsapp/health", {
        params: { _: Date.now() }
      });
      setWhatsAppHealth(data);
    } catch (error) {
      setWhatsAppHealth(null);
    }
  }, []);

  useEffect(() => {
    refreshWhatsAppHealth();
  }, [refreshWhatsAppHealth]);

  const refreshFilterOptions = useCallback(async () => {
    try {
      const { data } = await api.get("/tickets/filter-options", {
        params: { _: Date.now() }
      });
      setFilterOptions({
        users: Array.isArray(data?.users) ? data.users : [],
        queues: Array.isArray(data?.queues) ? data.queues : [],
        whatsapps: Array.isArray(data?.whatsapps) ? data.whatsapps : [],
        tags: Array.isArray(data?.tags) ? data.tags : []
      });
    } catch (error) {
      setFilterOptions({
        users: [],
        queues: [],
        whatsapps: [],
        tags: []
      });
    }
  }, []);

  useEffect(() => {
    refreshFilterOptions();
  }, [refreshFilterOptions]);

  useEffect(() => {
    const socket = openSocket();

    socket.on("whatsappSession", () => {
      refreshWhatsAppHealth();
    });

    socket.on("whatsapp", () => {
      refreshWhatsAppHealth();
    });

    return () => {
      socket.disconnect();
    };
  }, [refreshWhatsAppHealth]);

  useEffect(() => {
    return () => {
      Object.values(tabActivityTimeoutsRef.current).forEach(timeoutId => {
        clearTimeout(timeoutId);
      });
    };
  }, []);

  const refreshPendingCounters = useCallback(async () => {
    try {
      const commonParams = {
        pageNumber: 1,
        status: "pending",
        showAll: showAllTickets,
        queueIds: queueIdsParam,
        userIds: JSON.stringify(selectedUserIds),
        whatsappIds: JSON.stringify(selectedWhatsAppIds),
        tagIds: JSON.stringify(selectedTagIds),
        date: selectedDate || undefined
      };

      const [privateResponse, groupResponse] = await Promise.all([
        api.get("/tickets", {
          params: {
            ...commonParams,
            ticketType: "private"
          }
        }),
        api.get("/tickets", {
          params: {
            ...commonParams,
            ticketType: "group"
          }
        })
      ]);

      setPrivatePendingCount(privateResponse.data.count || 0);
      setGroupPendingCount(groupResponse.data.count || 0);
    } catch (error) {
      setPrivatePendingCount(0);
      setGroupPendingCount(0);
    }
  }, [
    queueIdsParam,
    selectedDate,
    selectedUserIds,
    selectedWhatsAppIds,
    selectedTagIds,
    showAllTickets
  ]);

  useEffect(() => {
    refreshPendingCounters();
  }, [refreshPendingCounters]);

  const refreshUnreadCounters = useCallback(async () => {
    try {
      const commonParams = {
        pageNumber: 1,
        status: "open",
        withUnreadMessages: "true",
        assignedOnlyUnread: "true"
      };

      const [privateResponse, groupResponse] = await Promise.all([
        api.get("/tickets", {
          params: {
            ...commonParams,
            ticketType: "private"
          }
        }),
        api.get("/tickets", {
          params: {
            ...commonParams,
            ticketType: "group"
          }
        })
      ]);

      setPrivateUnreadCount(privateResponse.data.count || 0);
      setGroupUnreadCount(groupResponse.data.count || 0);
    } catch (error) {
      setPrivateUnreadCount(0);
      setGroupUnreadCount(0);
    }
  }, []);

  useEffect(() => {
    refreshUnreadCounters();
  }, [refreshUnreadCounters]);

  const triggerTicketTypeActivity = useCallback(type => {
    if (!["private", "group"].includes(type)) {
      return;
    }

    setTabActivity(prevState => ({
      ...prevState,
      [type]: false
    }));

    window.clearTimeout(tabActivityTimeoutsRef.current[type]);

    window.requestAnimationFrame(() => {
      setTabActivity(prevState => ({
        ...prevState,
        [type]: true
      }));
    });

    tabActivityTimeoutsRef.current[type] = window.setTimeout(() => {
      setTabActivity(prevState => ({
        ...prevState,
        [type]: false
      }));
    }, 3200);
  }, []);

  useEffect(() => {
    const socket = openSocket();
    let unreadRefreshTimeoutId = null;
    let pendingRefreshTimeoutId = null;

    const scheduleUnreadRefresh = () => {
      if (unreadRefreshTimeoutId) {
        window.clearTimeout(unreadRefreshTimeoutId);
      }

      unreadRefreshTimeoutId = window.setTimeout(() => {
        refreshUnreadCounters();
      }, 220);
    };

    const schedulePendingRefresh = () => {
      if (pendingRefreshTimeoutId) {
        window.clearTimeout(pendingRefreshTimeoutId);
      }

      pendingRefreshTimeoutId = window.setTimeout(() => {
        refreshPendingCounters();
      }, 220);
    };

    const rememberMessageKey = messageKey => {
      if (!messageKey) {
        return false;
      }

      if (recentTabMessageIdsRef.current.has(messageKey)) {
        return true;
      }

      recentTabMessageIdsRef.current.add(messageKey);
      window.setTimeout(() => {
        recentTabMessageIdsRef.current.delete(messageKey);
      }, 5000);

      return false;
    };

    const resolveTicketType = ticket => {
      if (!ticket) {
        return null;
      }

      return ticket.isGroup ? "group" : "private";
    };

    const maybeTriggerActivity = (ticket, messageKey) => {
      const resolvedType = resolveTicketType(ticket);

      if (!resolvedType || rememberMessageKey(messageKey)) {
        return;
      }

      triggerTicketTypeActivity(resolvedType);
    };

    socket.on("connect", () => {
      socket.emit("joinNotification");
      socket.emit("joinTickets", "pending");
      socket.emit("joinTickets", "open");
      scheduleUnreadRefresh();
      schedulePendingRefresh();
    });

    socket.on("appMessage", data => {
      if (data?.action === "create" && !data?.message?.read) {
        maybeTriggerActivity(data.ticket, data.message?.id);
        scheduleUnreadRefresh();
      }
    });

    socket.on("ticket", data => {
      if (data?.action === "update" && data?.meta?.source === "message") {
        maybeTriggerActivity(data.ticket, data.meta?.messageId);
      }

      if (["update", "updateUnread", "create", "delete"].includes(data?.action)) {
        scheduleUnreadRefresh();
        schedulePendingRefresh();
      }
    });

    return () => {
      if (unreadRefreshTimeoutId) {
        window.clearTimeout(unreadRefreshTimeoutId);
      }
      if (pendingRefreshTimeoutId) {
        window.clearTimeout(pendingRefreshTimeoutId);
      }
      socket.disconnect();
    };
  }, [refreshPendingCounters, refreshUnreadCounters, triggerTicketTypeActivity]);

  const getPrimaryTabClassName = useCallback(
    type => {
      const classNames = [classes.primaryTabRoot];

      if (tabActivity[type]) {
        classNames.push(classes.primaryTabAlert);
        if (ticketType === type) {
          classNames.push(classes.primaryTabAlertSelected);
        }
      }

      return classNames.join(" ");
    },
    [classes.primaryTabAlert, classes.primaryTabAlertSelected, classes.primaryTabRoot, tabActivity, ticketType]
  );

  const renderTicketTypeLabel = useCallback(
    (label, pendingValue, unreadValue) => (
      <span className={classes.primaryTabLabelWrap}>
        <span className={classes.primaryTabLabelText}>{label}</span>
        <span className={classes.primaryTabCounters}>
          {pendingValue > 0 ? (
            <span className={`${classes.primaryCounterPill} ${classes.primaryCounterPending}`}>
              {pendingValue}
            </span>
          ) : null}
          {unreadValue > 0 ? (
            <span className={`${classes.primaryCounterPill} ${classes.primaryCounterUnread}`}>
              {unreadValue}
            </span>
          ) : null}
        </span>
      </span>
    ),
    [
      classes.primaryCounterPending,
      classes.primaryCounterPill,
      classes.primaryCounterUnread,
      classes.primaryTabCounters,
      classes.primaryTabLabelText,
      classes.primaryTabLabelWrap
    ]
  );

  let searchTimeout;

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setTab("open");
      return;
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
    }, 500);
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    setTabOpen(newValue);
  };

  const connectionAlertMessage = useMemo(() => {
    if (!whatsAppHealth?.hasIssue) {
      return "";
    }

    const notifyAdminSuffix =
      user?.profile?.toLowerCase() === "user"
        ? " Avise um administrador."
        : " Verifique as conexões.";

    if (whatsAppHealth.state === "no_connections") {
      return `A empresa está sem conexão WhatsApp configurada.${notifyAdminSuffix}`;
    }

    if (whatsAppHealth.state === "qrcode") {
      return `Há conexão WhatsApp aguardando QR Code.${notifyAdminSuffix}`;
    }

    if (whatsAppHealth.state === "connecting") {
      return `A conexão WhatsApp está instável no momento.${notifyAdminSuffix}`;
    }

    return `A empresa está sem conexão WhatsApp ativa.${notifyAdminSuffix}`;
  }, [whatsAppHealth, user?.profile]);

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const syncDraftFiltersFromApplied = useCallback(() => {
    setDraftSelectedQueueIds(selectedQueueIds || []);
    setDraftSelectedDate(selectedDate);
    setDraftSelectedUserId(selectedUserId);
    setDraftSelectedWhatsAppId(selectedWhatsAppId);
    setDraftSelectedTagValues(selectedTagValues);
  }, [
    selectedDate,
    selectedQueueIds,
    selectedTagValues,
    selectedUserId,
    selectedWhatsAppId
  ]);

  const handleOpenAdvancedFilters = () => {
    syncDraftFiltersFromApplied();
    setAdvancedFiltersOpen(true);
  };

  const handleCloseAdvancedFilters = () => {
    setAdvancedFiltersOpen(false);
  };

  const handleResetDraftAdvancedFilters = () => {
    setDraftSelectedQueueIds(userQueueIds || []);
    setDraftSelectedDate("");
    setDraftSelectedUserId("");
    setDraftSelectedWhatsAppId("");
    setDraftSelectedTagValues([]);
  };

  const handleApplyAdvancedFilters = () => {
    setSelectedQueueIds(draftSelectedQueueIds || []);
    setSelectedDate(draftSelectedDate);
    setSelectedUserId(draftSelectedUserId);
    setSelectedWhatsAppId(draftSelectedWhatsAppId);
    setSelectedTagValues(draftSelectedTagValues);
    setAdvancedFiltersOpen(false);
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(e) => setNewTicketModalOpen(false)}
      />
      <Paper elevation={0} square className={classes.tabsHeader}>
        {shouldShowTicketTypeTabs && (
          <Tabs
            value={ticketType}
            onChange={(e, newValue) => setTicketType(newValue)}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="primary"
            aria-label="conversation type tabs"
            className={classes.primaryTabs}
          >
            <Tab
              value="private"
              icon={<ChatBubbleOutlineIcon />}
              label={renderTicketTypeLabel("Individuais", privatePendingCount, privateUnreadCount)}
              className={getPrimaryTabClassName("private")}
              classes={{ root: classes.primaryTabRoot }}
            />
            <Tab
              value="group"
              icon={<GroupOutlinedIcon />}
              label={renderTicketTypeLabel("Grupos", groupPendingCount, groupUnreadCount)}
              className={getPrimaryTabClassName("group")}
              classes={{ root: classes.primaryTabRoot }}
            />
          </Tabs>
        )}
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          aria-label="icon label tabs example"
          className={classes.secondaryTabs}
        >
          <Tab
            value={"open"}
            icon={<MoveToInboxIcon />}
            label={i18n.t("tickets.tabs.open.title")}
            classes={{ root: classes.secondaryTabRoot }}
          />
          <Tab
            value={"closed"}
            icon={<CheckBoxIcon />}
            label={i18n.t("tickets.tabs.closed.title")}
            classes={{ root: classes.secondaryTabRoot }}
          />
          <Tab
            value={"search"}
            icon={<SearchIcon />}
            label={i18n.t("tickets.tabs.search.title")}
            classes={{ root: classes.secondaryTabRoot }}
          />
        </Tabs>
      </Paper>
      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        {tab === "search" ? (
          <div className={classes.serachInputWrapper}>
            <SearchIcon className={classes.searchIcon} />
            <InputBase
              className={classes.searchInput}
              inputRef={searchInputRef}
              placeholder={i18n.t("tickets.search.placeholder")}
              type="search"
              onChange={handleSearch}
            />
          </div>
        ) : (
          <>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setNewTicketModalOpen(true)}
              className={classes.actionButton}
            >
              {i18n.t("ticketsManager.buttons.newTicket")}
            </Button>
            <Can
              role={user.profile}
              perform="tickets-manager:showall"
              yes={() => (
                <FormControlLabel
                  label={i18n.t("tickets.buttons.showAll")}
                  labelPlacement="start"
                  control={
                    <Switch
                      size="small"
                      checked={showAllTickets}
                      onChange={() =>
                        setShowAllTickets((prevState) => !prevState)
                      }
                      name="showAllTickets"
                      color="primary"
                    />
                  }
                />
              )}
            />
          </>
        )}
        <Button
          variant={advancedFiltersOpen || hasAdvancedFiltersApplied ? "contained" : "outlined"}
          color="primary"
          onClick={handleOpenAdvancedFilters}
          className={classes.filterToggleButton}
          startIcon={<TuneIcon />}
        >
          {activeAdvancedFiltersCount > 0
            ? `Filtros (${activeAdvancedFiltersCount})`
            : "Filtros"}
        </Button>
      </Paper>
      {hasAdvancedFiltersApplied && (
        <div className={classes.activeFiltersSummary}>
          {activeAdvancedFiltersCount} filtro{activeAdvancedFiltersCount > 1 ? "s ativos" : " ativo"}
        </div>
      )}
      <Drawer
        anchor="right"
        open={advancedFiltersOpen}
        onClose={handleCloseAdvancedFilters}
        classes={{ paper: classes.drawerPaper }}
      >
        <div className={classes.drawerHeader}>
          <span className={classes.drawerTitle}>Filtros avançados</span>
          <span className={classes.drawerSubtitle}>
            Refine a operação por fila, atendente, conexão, data e tags sem perder a visão da lista.
          </span>
        </div>
        <div className={classes.advancedFiltersWrap}>
          <div className={classes.advancedFiltersGrid}>
            <TicketsQueueSelect
              selectedQueueIds={draftSelectedQueueIds}
              userQueues={availableQueues}
              onChange={(values) => setDraftSelectedQueueIds(values)}
            />
            <TextField
              select
              fullWidth
              size="small"
              variant="outlined"
              label="Atendente"
              className={classes.filterField}
              value={draftSelectedUserId}
              onChange={(event) => setDraftSelectedUserId(event.target.value)}
            >
              <MenuItem value="">Todos</MenuItem>
              {filterOptions.users.map((option) => (
                <MenuItem key={option.id} value={String(option.id)}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              select
              fullWidth
              size="small"
              variant="outlined"
              label="Conexão"
              className={classes.filterField}
              value={draftSelectedWhatsAppId}
              onChange={(event) => setDraftSelectedWhatsAppId(event.target.value)}
            >
              <MenuItem value="">Todas</MenuItem>
              {filterOptions.whatsapps.map((option) => (
                <MenuItem key={option.id} value={String(option.id)}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="Data"
              type="date"
              className={classes.filterField}
              value={draftSelectedDate}
              onChange={(event) => setDraftSelectedDate(event.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <FormControl
              fullWidth
              size="small"
              variant="outlined"
              className={classes.filterField}
            >
              <InputLabel id="tickets-tag-filter-label">Tags</InputLabel>
              <Select
                labelId="tickets-tag-filter-label"
                multiple
                value={draftSelectedTagValues}
                onChange={(event) => setDraftSelectedTagValues(event.target.value)}
                label="Tags"
                renderValue={(selected) => {
                  if (!selected.length) {
                    return "Todas";
                  }

                  return filterOptions.tags
                    .filter((tag) => selected.includes(String(tag.id)))
                    .map((tag) => tag.name)
                    .join(", ");
                }}
              >
                {filterOptions.tags.map((option) => (
                  <MenuItem key={option.id} value={String(option.id)}>
                    <Chip
                      size="small"
                      label={option.name}
                      style={{
                        backgroundColor: `${option.color}22`,
                        color: option.color,
                        fontWeight: 700
                      }}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className={classes.advancedFiltersFooter}>
            <span className={classes.filterHint}>
              Combine fila, atendente, conexão, data e tags para chegar mais rápido na conversa certa.
            </span>
            <div className={classes.drawerActions}>
              <Button
                color="primary"
                size="small"
                startIcon={<ClearAllIcon />}
                onClick={handleResetDraftAdvancedFilters}
              >
                Limpar
              </Button>
              <div className={classes.drawerPrimaryActions}>
                <Button onClick={handleCloseAdvancedFilters}>
                  Cancelar
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleApplyAdvancedFilters}
                >
                  Aplicar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
      {connectionAlertMessage && (
        <div className={classes.connectionAlert}>
          <WarningIcon className={classes.connectionAlertIcon} />
          <span>{connectionAlertMessage}</span>
        </div>
      )}
      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          className={classes.statusTabs}
        >
          <Tab
            label={
              <Badge
                className={classes.badge}
                badgeContent={openCount}
                color="primary"
              >
                {i18n.t("ticketsList.assignedHeader")}
              </Badge>
            }
            value={"open"}
            classes={{ root: classes.statusTabRoot }}
          />
          <Tab
            label={
              <Badge
                className={classes.badge}
                badgeContent={pendingCount}
                color="secondary"
              >
                {i18n.t("ticketsList.pendingHeader")}
              </Badge>
            }
            value={"pending"}
            classes={{ root: classes.statusTabRoot }}
          />
        </Tabs>
        <Paper className={classes.ticketsWrapper}>
          <TicketsList
            status="open"
            showAll={showAllTickets}
            ticketType={ticketType}
            selectedQueueIds={selectedQueueIds}
            selectedUserIds={selectedUserIds}
            selectedWhatsAppIds={selectedWhatsAppIds}
            selectedTagIds={selectedTagIds}
            selectedDate={selectedDate}
            updateCount={(val) => setOpenCount(val)}
            style={applyPanelStyle("open")}
          />
          <TicketsList
            status="pending"
            showAll={showAllTickets}
            ticketType={ticketType}
            selectedQueueIds={selectedQueueIds}
            selectedUserIds={selectedUserIds}
            selectedWhatsAppIds={selectedWhatsAppIds}
            selectedTagIds={selectedTagIds}
            selectedDate={selectedDate}
            updateCount={(val) => setPendingCount(val)}
            style={applyPanelStyle("pending")}
          />
        </Paper>
      </TabPanel>
      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={true}
          ticketType={ticketType}
          selectedQueueIds={selectedQueueIds}
          selectedUserIds={selectedUserIds}
          selectedWhatsAppIds={selectedWhatsAppIds}
          selectedTagIds={selectedTagIds}
          selectedDate={selectedDate}
        />
      </TabPanel>
      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        <TicketsList
          searchParam={searchParam}
          showAll={true}
          ticketType={ticketType}
          selectedQueueIds={selectedQueueIds}
          selectedUserIds={selectedUserIds}
          selectedWhatsAppIds={selectedWhatsAppIds}
          selectedTagIds={selectedTagIds}
          selectedDate={selectedDate}
        />
      </TabPanel>
    </Paper>
  );
};

export default TicketsManager;
